import { render, staticRenderFns } from "./StoreMarket.vue?vue&type=template&id=5606ccb8&scoped=true"
import script from "./StoreMarket.vue?vue&type=script&lang=js"
export * from "./StoreMarket.vue?vue&type=script&lang=js"
import style0 from "./StoreMarket.vue?vue&type=style&index=0&id=5606ccb8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5606ccb8",
  null
  
)

export default component.exports